export default __webpack_public_path__ + "static/media/bg-login2.923a4c7a.webp";